import * as yup from "yup";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";

import Textbox from "../../../../../components/common/Textbox";
import Toaster from "../../../../../components/common/Toaster";

import accountService from "../../../../../services/accountService";
import moment from "moment";

const schema = yup.object({
  email: yup.string().required("Please enter a valid email address."),
});

const EmailForm = ({ id, isLoading, setLoading, onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const { result } = await accountService.saveEmailAsync(id, data.email);

      const item = {
        id: result,
        email: data.email,
        created_on: moment().toISOString(),
      };

      onSuccess(item);
      setLoading(false);
      Toaster.Success("Email Added Succesfully");
    } catch (ex) {
      console.log(ex);
      setLoading(false);
      Toaster.Error("Something went wrong.");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Textbox
            id="email-textbox"
            name="email"
            title="Email Address"
            type="email"
            register={register("email")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default EmailForm;
